import { ECBasicOption } from 'echarts/types/dist/shared'
import { forEach, includes } from 'lodash-es'
import { storeToken } from './auth-service'
import { apiRequest } from './http-service'
import { LogRow } from '@/types/api/admin/log-row'

async function login(username: string, password: string) {
  const { token } = await apiRequest<{ token: string }>('GET', 'admin/authenticate', { params: { username, password } })
  storeToken(token)
}

function logout() {
  storeToken(null)
}

async function getRequestLogs(requestId?: string, fromDate?: string) {
  return apiRequest<LogRow[][]>('GET', 'admin/requestlogs', { params: { requestId, fromDate } }).then(groups => {
    forEach(groups, group => {
      forEach(group, log => {
        if(log.contextData) {
          log.contextData = JSON.parse(log.contextData)
        }
      })
    })
    return groups
  })
}

async function createEndUserToken(requestId: string) {
  return apiRequest<{ token: string }>('GET', 'admin/token', { params: { requestId } })
}

async function createDevelopmentToken(requestId: string) {
  await login('admin', 'f6e929bc-521b-48ca-ac57-66c422b5c7be')
  const { token: endUserToken } = await createEndUserToken(requestId)
  storeToken(endUserToken)
}

export type ParseResponse = { excelReportDownloadUrl: string, clicksPerSmsChartOptions: ECBasicOption }

async function parseTinyUrlFiles(files: File[]) {
  const formData = new FormData()
  forEach(files, file => {
    if(includes(file.name, '_list')) {
      formData.append('links', file)
    } else {
      formData.append('analytics', file)
    }
  })
  return apiRequest<ParseResponse>('POST', 'admin/parseTinyUrlData', {
    data: formData
  })
}

export { createEndUserToken, login, createDevelopmentToken, logout, parseTinyUrlFiles, getRequestLogs }
